var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.68 178.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20232a",
    d: "M67.15,24a43.14,43.14,0,1,0,43.14,43.13A43.18,43.18,0,0,0,67.15,24Zm0,82.36a39.23,39.23,0,1,1,39.23-39.23A39.27,39.27,0,0,1,67.15,106.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20232a",
    d: "M174,156.85l-51.57-51.58a67.23,67.23,0,1,0-18,17.73l51.72,51.72A12.63,12.63,0,1,0,174,156.85ZM7.81,67.15a59.34,59.34,0,1,1,59.34,59.34A59.41,59.41,0,0,1,7.81,67.15Zm160.65,102a4.82,4.82,0,0,1-6.81,0l-51-50.95a68.51,68.51,0,0,0,6.87-6.76l50.9,50.9A4.82,4.82,0,0,1,168.46,169.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.708b5977.svg";
export { ForwardRef as ReactComponent };